import { Extension } from '@tiptap/core'

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        segmentDistance: {
            setMarginTop: (value: string) => ReturnType
            unsetMarginTop: () => ReturnType
            setMarginBottom: (value: string) => ReturnType
            unsetMarginBottom: () => ReturnType
        }
    }
}

type SegmentDistanceOptions = {
    types: string[]
    defaultMarginTop: string
    defaultMarginBottom: string
}

export const SegmentDistance = Extension.create<SegmentDistanceOptions>({
    name: 'segmentDistance',

    addOptions() {
        return {
            types: ['paragraph', 'heading'],
            defaultMarginTop: '0',
            defaultMarginBottom: '0'
        }
    },

    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    marginTop: {
                        default: this.options.defaultMarginTop,
                        parseHTML: element => element.style.marginTop?.replace('px', '') || this.options.defaultMarginTop,
                        renderHTML: attributes => {
                            if (!attributes.marginTop || attributes.marginTop === this.options.defaultMarginTop) {
                                return {}
                            }
                            return {
                                style: `margin-top: ${attributes.marginTop}px;`
                            }
                        }
                    },
                    marginBottom: {
                        default: this.options.defaultMarginBottom,
                        parseHTML: element => element.style.marginBottom?.replace('px', '') || this.options.defaultMarginBottom,
                        renderHTML: attributes => {
                            if (!attributes.marginBottom || attributes.marginBottom === this.options.defaultMarginBottom) {
                                return {}
                            }
                            return {
                                style: `margin-bottom: ${attributes.marginBottom}px;`
                            }
                        }
                    }
                }
            }
        ]
    },

    addCommands() {
        return {
            setMarginTop:
                value =>
                ({ commands }) => {
                    return this.options.types.map(type => commands.updateAttributes(type, { marginTop: value })).every(Boolean)
                },
            unsetMarginTop:
                () =>
                ({ commands }) => {
                    return this.options.types.map(type => commands.resetAttributes(type, 'marginTop')).every(Boolean)
                },
            setMarginBottom:
                value =>
                ({ commands }) => {
                    return this.options.types.map(type => commands.updateAttributes(type, { marginBottom: value })).every(Boolean)
                },
            unsetMarginBottom:
                () =>
                ({ commands }) => {
                    return this.options.types.map(type => commands.resetAttributes(type, 'marginBottom')).every(Boolean)
                }
        }
    }
})
